import { Component, EventEmitter, Output, Input, OnInit } from '@angular/core';
import { State } from 'app/models/State';
import { PlantService } from 'app/services/plant.service';

@Component({
  selector: 'app-nursery-filter',
  templateUrl: './nursery-filter.component.html',
  styleUrls: ['./nursery-filter.component.scss']
})
export class NurseryFilterComponent implements OnInit {
  packagingTypes: string[] = [];
  @Input() states: State[] = [];
  @Input() filter: any;
  @Input() searchKeyword: string = '';
  @Output() filtersChanged = new EventEmitter<any>();
  @Output() resetFilter = new EventEmitter<void>();

  constructor(private plantService: PlantService) {
    this.plantService.getPackagingTypes().subscribe(packagingTypes => {
      this.packagingTypes = packagingTypes;
    });
  }

  ngOnInit() {
    if (this.searchKeyword) {
      this.filter.keyword = this.searchKeyword;
    }
  }

  onSubmit() {
    this.filtersChanged.emit(this.filter);
  }

  onReset() {
    this.resetFilter.emit();
  }
}
